import React, { useRef, useState, useEffect } from "react";
import { FaPeopleGroup } from "react-icons/fa6";
import {
  FaBookmark,
  FaRegBookmark,
} from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import BaseUrl from "../../Components/BaseUrl";
import Cookies from "js-cookie";
import { PiDotsThree } from "react-icons/pi";

const SavedPost = () => {
  const location = useLocation();
  const [showOptions, setShowOptions] = useState(false);
  const optionsRef = useRef(null);
  const buttonRef = useRef(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isSaved, setIsSaved] = useState([]);
  

  const [isLoading, setIsLoading] = useState(false);
  const [savedPost, setSavedPost] = useState([]);
  const menuItems = [
    {
      path: "/my-items/saved-post",
      label: "Saved posts and articles",
      count: savedPost.length,
    },
  ];
  useEffect(() => {
    getsavedPost();
  }, []);

  const getsavedPost = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(BaseUrl + `getsavedposts`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          Accept: "application/json",
        },
      });
      const savedPost = response.data.data.saved_feed;
      setSavedPost(savedPost);
      const initialisSaved = {};
      savedPost.forEach((post) => {
        initialisSaved[post.id] = post.is_saved;
      });
      setIsSaved(initialisSaved);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleToggleSaveUnsave = async (id, type) => {
    const wasSaved = isSaved[id];
    setIsSaved((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
    setShowOptions(false);

    try {
      if (wasSaved) {
        const response = await axios.post(
          `${BaseUrl}unsavepost`,
          {
            saved_type: type,
            savable_id: id,
          },
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("token")}`,
              Accept: "application/json",
            },
          }
        );
        if (response.data.status === 200) {
          setSavedPost((prevPosts) =>
            prevPosts.filter((post) => post.id !== id)
          );
        } else {
          setIsSaved((prevState) => ({
            ...prevState,
            [id]: wasSaved,
          }));
        }
      } else {
        await axios.post(
          `${BaseUrl}savepost`,
          {
            saved_type: "post",
            savable_id: id,
          },
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("token")}`,
              Accept: "application/json",
            },
          }
        );
      }
    } catch (error) {
      console.log(error);
      setIsSaved((prevState) => ({
        ...prevState,
        [id]: wasSaved,
      }));
    }
  };

  return (
    <>
      {isLoading ? (
        <div className="absolute inset-0 bg-white bg-opacity-50 flex items-center justify-center z-10">
          <img src="/Images/loader.gif" className="h-16 w-16 bg-opacity-50" />
        </div>
      ) : (
        <div className="bg-[#F3F2EF] mt-10 ">
          <div className=" container mx-auto flex flex-col lg:flex-row py-4 px-4 sm:px-6 lg:px-8">
            <div className="w-full lg:w-1/4 pt-6 pr-4">
              <div className="flex flex-col bg-white rounded-lg border shadow-sm overflow-hidden">
                <div className="flex items-center space-x-2 border-b px-5 py-4 text-gray-700">
                  <FaBookmark className=" text-xl" />
                  <p className="text-xl font-semibold">My Items</p>
                </div>
                <div className="flex flex-col divide-y">
                  {menuItems.map((item) => {
                    const isActive = location.pathname === item.path;
                    return (
                      <Link key={item.path} to={item.path}>
                        <div
                          className={`flex items-center justify-between px-5 py-3 transition-all duration-200 ${
                            isActive
                              ? "border-l-4 border-blue-600 text-md font-medium text-blue-800"
                              : "text-gray-600 hover:bg-gray-50 hover:text-blue-700"
                          }`}
                        >
                          <span className="text-md">{item.label}</span>
                          <span className="bg-gray-100 text-gray-700 text-xs font-semibold rounded-full w-6 h-6 flex items-center justify-center">
                            {item.count}
                          </span>
                        </div>
                      </Link>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="w-full lg:w-2/4 mt-6">
              <div className="bg-white rounded-lg border shadow-sm overflow-hidden">
                <div className="flex items-center space-x-2  px-5 pt-3 text-gray-700">
                  <p className="text-xl font-semibold">Saved Posts</p>
                </div>
                <div className="px-5 py-2 border-b-2 border-gray-200">
                  <button className="bg-green-600 text-white text-sm font-semibold px-3 py-1 rounded-full">
                    All
                  </button>
                </div>
                <div className=" ">
                  {savedPost.length === 0 ? (
                    <div className="flex flex-col items-center justify-center py-10 px-5 text-center">
                      <FaBookmark className="text-4xl text-gray-400 mb-4" />
                      <h3 className="text-xl font-semibold text-gray-700 mb-2">
                        No saved posts yet
                      </h3>
                      <p className="text-gray-500 max-w-md">
                        When you save posts or articles, they'll appear here for
                        easy access.
                      </p>
                    </div>
                  ) : (
                    savedPost.map((post, index) => (
                      <div
                        key={post.id}
                        className="py-2 flex flex-col border-b px-5 hover:bg-gray-50 transition-all duration-200 "
                      >
                        <div className="relative flex justify-between">
                          <div className="flex space-x-4 items-start">
                            <img
                              src={post.user.profile || "/Images/user-img.jpg"}
                              alt="avatar"
                              className="h-12 w-12 rounded-full object-cover shadow-sm"
                            />
                            <div className="flex-1">
                              <div className="flex items-center space-x-1">
                                <p className="font-semibold text-gray-800">
                                  {post.user.name}
                                </p>
                              </div>
                              <div className="flex items-center space-x-2">
                                <p className="text-sm text-gray-600">
                                  {post.user.headline}
                                </p>
                                <span className="text-xs text-gray-400 mt-1">
                                  {post.time} • 🌍
                                </span>
                              </div>
                            </div>
                          </div>
                          <PiDotsThree
                            className="text-2xl cursor-pointer hover:text-gray-700"
                            onClick={() => {
                              setShowOptions(!showOptions);
                              setSelectedIndex(index);
                            }}
                            ref={buttonRef}
                          />
                          {showOptions && index === selectedIndex && (
                            <div
                              ref={optionsRef}
                              className="absolute bg-white border border-gray-300 shadow-lg rounded-b-lg rounded-tl-lg z-50 mt-5 w-56 right-1 overflow-hidden"
                            >
                              <button
                                className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100 transition-colors"
                                onClick={() => {
                                  handleToggleSaveUnsave(post.id, post.type);
                                }}
                              >
                                {isSaved[post.id] ? (
                                  <FaBookmark />
                                ) : (
                                  <FaRegBookmark />
                                )}
                                {isSaved[post.id] ? "Unsave" : "Save"}
                              </button>
                            </div>
                          )}
                        </div>
                        <div className="mt-2 flex flex-col sm:flex-row sm:space-x-4 space-y-3 sm:space-y-0">
                          {post.type === "group_poll" ? (
                            <Link to={`/saved-post/${post.type}/${post.id}`}>
                              <div className="w-full bg-gray-200 rounded-lg p-4">
                                <p className="text-md font-medium text-gray-800 mb-2">
                                  🗳️ {post.question}
                                </p>
                                <p className="text-sm text-gray-500">
                                  <span className="font-normal text-xs">
                                    Poll • {post.total_vote} votes •{" "}
                                    {post.is_open ? "Poll open" : "Poll closed"}
                                  </span>
                                </p>
                              </div>
                            </Link>
                          ) : post.type === "event" ? (
                            <Link
                              to={`/saved-post/${post.type}/${post.id}`}
                              className="flex space-x-4 w-full"
                            >
                              <div className="sm:w-2/5">
                                {post.media.url && (
                                  <img
                                    src={post.media.url}
                                    alt="event"
                                    className="w-full h-32 object-cover rounded-xl shadow-md"
                                  />
                                )}
                              </div>
                              <div className="sm:w-4/5">
                                <p className="text-sm text-gray-800 leading-relaxed">
                                  {post.event_name}{" "}
                                  <span className="text-blue-600 hover:underline cursor-pointer">
                                    ...see more
                                  </span>
                                </p>
                              </div>
                            </Link>
                          ) : (
                            <Link
                              to={`/saved-post/${post.type}/${post.id}`}
                              className="flex space-x-4 w-full"
                            >
                              <div className="sm:w-1/5">
                                {post.media?.length > 0 &&
                                  post.media[0].url && (
                                    <img
                                      src={post.media[0].url}
                                      alt="post"
                                      className="w-full h-32 object-cover rounded-xl shadow-md"
                                    />
                                  )}
                              </div>
                              <div className="sm:w-4/5">
                                <p className="text-sm text-gray-800 leading-relaxed">
                                  {post.content}{" "}
                                  <span className="text-blue-600 hover:underline cursor-pointer">
                                    ...see more
                                  </span>
                                </p>
                              </div>
                            </Link>
                          )}
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
            <div className="w-full lg:w-1/4 p-4 mt-2">
              <div className=" rounded-lg">
                <img
                  src="/Images/newsfeed/RightBannerCard.png"
                  alt="Digital Marketing"
                  className="w-full rounded-lg"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SavedPost;